/**
 * Route level error page.
 *
 * A render or loader failure must not leave the user on a blank screen, so the
 * router renders this instead and offers the two recoveries that always work:
 * retry the route, or go home.
 */

import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router'
import { useTranslation } from 'react-i18next'

import { Button } from '../components/ui/button'
import { EmptyState } from '../components/ui/primitives'

export function RouteErrorPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const error = useRouteError()

  const description = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : null

  return (
    <div className="container-narrow">
      <EmptyState
        className="mt-8"
        title={t('error.internal_error')}
        description={description}
        action={
          <div className="flex gap-2 pt-2">
            <Button onClick={() => navigate(0)}>{t('common.retry')}</Button>
            <Button variant="outline" onClick={() => navigate('/')}>
              {t('nav.home')}
            </Button>
          </div>
        }
      />
    </div>
  )
}
